import React, { Component } from 'react';
import { Select, Input, Divider, Row, Checkbox, Button, message, Tag, InputNumber } from 'antd';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { schema_to_field, showErrorInNotification } from '../../../lib/util';
import Title from 'antd/lib/typography/Title';
import Form from '../../../lib/ui/form';
import ScheduleChanger from '../../../components/schedule_changer';

import { JsonEditor as Editor } from 'jsoneditor-react';
import 'jsoneditor-react/es/editor.min.css';

import ace from 'brace';
import 'brace/mode/json';
import 'brace/theme/tomorrow_night_blue';



const extensions_list = [
  // {text:"",value:""}
]
class RepositoryConfigAddEdit extends Component {
  constructor(props) {
    super(props)

    this.state = {
      form_data: this.props.edit_data || {},
      edit_id: this.props.edit_id,
      fetchers: {},
      fetcherSchema: []
    };



    this.list_fetchers = RESTExecutor.list().config({
      label: 'fetchers',
      params: {
        pagination: false
      }
    }).callbacks((success) => {
      let fetchers = {};
      success.result.rows.map((item) => {
        fetchers[item.id] = item
      });
      this.setState({
        fetchers: fetchers
      });

      if (this.props.edit_id) {
        this.setState({
          fetcherSchema: schema_to_field(fetchers[this.props.edit_data.fetcher_id].validation_config || {})
        })
      }

    })
      .connect(props.domains.settings);


    this.post_fetcher_config = RESTExecutor.post().config({
      label: 'list'
    }).callbacks((success) => {
      message.success("Repository Added Successfully");
      typeof this.props.onRefreshClose === 'function' && this.props.onRefreshClose()

    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.datarepository);

    this.patch_fetcher_config = RESTExecutor.patch().config({
      label: 'detail',
      // params: {
      //   source_id: this.props.source_id,
      //   config_id: this.props.edit_id
      // }
    }).callbacks((success) => {
      message.success("Repository Modified Successfully");
      typeof this.props.onRefreshClose === 'function' && this.props.onRefreshClose()


    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.datarepository);

  };

  stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
    let newData = this.state[stateKey];
    this.has_changed = true;
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj)
    }
    // console.log(newData);
    this.setState({
      [stateKey]: newData
    }, () => {
      typeof callback === 'function' && callback()
    })
  }

  handlePostPatch = () => {
    if (this.state.edit_id) {
      this.patch_fetcher_config.forId(this.state.edit_id).execute(this.state.form_data)
    } else {
      this.post_fetcher_config.execute(this.state.form_data);
    }
  }

  scheduleUpdater = ({ key, value }) => {
    let form_data = this.state.form_data;
    if (!form_data.schedule) {
      form_data.schedule = {}
    }
    form_data.schedule[key] = value;
    this.setState({
      form_data: form_data
    })
  }





  render() {
    const { fetchers, form_data, edit_id, source_id } = this.state;
    let schedule = form_data.schedule || {};

    // console.log("days list",day_list)
    return (
      <div>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
        }}>
          <Row type='flex' justify='center' style={{
            flex: 1
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              width: 'fit-content',
              textAlign: 'right',
              justifyContent: 'center'
            }}
            >
              <span>
                Repository Name: &nbsp; <Input
                  placeholder={"Repository  Name"}
                  onChange={(e) => {
                    this.stateUpdater({ stateKey: 'form_data', valueKey: 'name', value: e.target.value })
                  }}
                  value={form_data.name}
                  style={{
                    width: 300
                  }} >
                </Input>
              </span>
              <br></br>
              <span>
                Repository Description: &nbsp; <Input.TextArea
                  placeholder={"Repository  Description"}
                  onChange={(e) => {
                    this.stateUpdater({ stateKey: 'form_data', valueKey: 'description', value: e.target.value })
                  }}
                  value={form_data.description}
                  style={{
                    width: 300
                  }} >
                </Input.TextArea>
              </span>
              <br></br>
              <span>Supported Extensions: <Select style={{ width: 300 }}
                placeholder="Supported Extensions"
                mode='tags'
                value={form_data.supported_extensions}
                onChange={(value) => {
                  this.stateUpdater({
                    stateKey: 'form_data', valueKey: 'supported_extensions', value: value
                  });
                }}>
                {extensions_list.map((item) => {
                  return <Select.Option value={item.value} key={item.value}>{item.text}</Select.Option>
                })}
                {/* <Select.Option value={'scheduled'} key={'scheduled'}>Schedule</Select.Option> */}
              </Select>
              </span>
              <br></br>
              <span>
                Max File Size(in MB): &nbsp; <InputNumber
                  style={{
                    width: 300
                  }}
                  placeholder={"Max File Size"}
                  value={form_data.max_size}
                  onChange={(value) => {
                    this.stateUpdater({
                      stateKey: 'form_data', valueKey: 'max_size', value: value
                    });
                  }}
                />
              </span>

              <br></br>
              <span>Fetcher: <Select style={{ width: 300 }}
                placeholder="Fetcher"
                filterOption={(input, option) => option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                showSearch
                value={form_data.fetcher_id}
                onChange={(value) => {
                  this.stateUpdater({
                    stateKey: 'form_data', valueKey: 'fetcher_id', value: value, callback: () => {
                      this.stateUpdater({ stateKey: 'form_data', valueKey: 'params', value: {} })
                    }
                  });
                  this.setState({
                    fetcherSchema: schema_to_field(fetchers[value].validation_config || {})
                  })
                }}


              >
                {
                  Object.keys(fetchers).map((key, index) => {
                    let item = fetchers[key];
                    return <Select.Option value={item.id} key={item.id}>
                      {item.name}
                    </Select.Option>
                  })
                }

              </Select>
              </span>
            </div>
          </Row>
          <br></br>
          {this.state.fetcherSchema.length > 0 ?
            <React.Fragment>
              <Divider style={{
                marginTop: 8,
                marginBottom: 8
              }} />

              <Title style={{ margin: 0 }} level={4} type='secondary'>Params</Title>
              <Form
                hideTitle
                forCreate={true}
                initialData={form_data.params || {}}
                submitted={this.state.submitted}
                onChange={(data) => {
                  console.log("Changes", data);
                  this.stateUpdater({
                    stateKey: 'form_data',
                    valueKey: 'params',
                    value: data,
                  });
                }}
                fields={this.state.fetcherSchema}
                submitting={{}}
                errorMessage={{}}
                validationErrors={{}}
              />
            </React.Fragment>
            : null}

          <React.Fragment>
            <Divider style={{
              marginTop: 8,
              marginBottom: 8
            }} />
            <Title style={{ margin: 0 }} level={4} type='secondary'>Schedule</Title>
            <ScheduleChanger
              schedule={schedule}
              onChange={(schedule) => {
                console.log("Schedule is", schedule)
                this.stateUpdater({ stateKey: 'form_data', valueKey: 'schedule', value: schedule })

              }}
            />
          </React.Fragment>


          <Divider style={{
            marginTop: 12,
            marginBottom: 8
          }} />
          <span>Extra Values</span>
          <div className='json-editor-wrapper'>
            <Editor
              mode={Editor.modes.code}
              value={form_data.extra_values || {}}
              onChange={(value) => {
                console.log("change value is", value);

                this.stateUpdater({ stateKey: 'form_data', valueKey: 'extra_values', value: value })

              }}
              className='small-json-editor'
              search={false}
              navigationBar={false}
              statusBar={false}
              ace={ace}
              // theme="ace/theme/github"
            /></div>
          
          {this.state.edit_id?<>
            <Divider style={{
            marginTop: 12,
            marginBottom: 8
          }} />
          <span>Progress Values</span>
          <div className='json-editor-wrapper'>
            <Editor
              mode={Editor.modes.code}
              value={form_data.progress || {}}
              onChange={(value) => {
                console.log("change value is", value);

                this.stateUpdater({ stateKey: 'form_data', valueKey: 'progress', value: value })

              }}
              className='small-json-editor'
              search={false}
              navigationBar={false}
              statusBar={false}
              ace={ace}
              // theme="ace/theme/github"
            /></div></>:null}

         
          <Row style={{marginTop:12}} type='flex' justify='space-between'>
            <div>
              <Button type='link' style={{ color: 'red' }} onClick={() => {
                typeof this.props.onClose === 'function' && this.props.onClose()
              }}>Cancel</Button>
            </div>
            <div>
              <Button 
              type='primary' 
              loading={this.post_fetcher_config.response().fetching || this.patch_fetcher_config.response().fetching}
              disabled={this.post_fetcher_config.response().fetching || this.patch_fetcher_config.response().fetching}
              onClick={() => {
                this.handlePostPatch()
              }}>Submit</Button>
            </div>
          </Row>


        </div>

      </div>
    );
  }

  componentDidMount() {
    this.list_fetchers.execute()
  }


  componentDidUpdate = (prevProps) => {
    if (this.props.edit_id !== prevProps.edit_id || this.props.edit_data !== prevProps.edit_data) {
      this.list_fetchers.execute()
      this.setState({
        edit_id: this.props.edit_id,
        form_data: this.props.edit_data
      })
    };

  }

}

export default withDomains(RepositoryConfigAddEdit, "settings", "datarepository");
